let appVersionMismatch = false;
export function checkForAppVersionMismatch(newVersion) {
    if (newVersion && window.__GLOBAL_CONTEXT__ && newVersion !== window.__GLOBAL_CONTEXT__.appVersion) {
        setTimeout(() => (appVersionMismatch = true), 60 * 60 * 1000);
    }
}
export function isAppVersionMismatch() {
    if (appVersionMismatch) {
        appVersionMismatch = false;
        return true;
    }
    return appVersionMismatch;
}
